import React, { Suspense, lazy } from 'react';
import {
    Link,
    Routes,
    Navigate,
    Route,
} from 'react-router-dom';
import Container from '@mui/material/Container';
import withRoot from '../../wiring/with-root';
import themer from '../../styles/material-theme';
import Colors from '../../styles/colors';

import Header from '../../components/header-flow';

const SDMLearn = lazy(() => import('../../routes/learn/decision-making-tools/sdm-flows/learn'));
const SDMForm = lazy(() => import('../../routes/learn/decision-making-tools/sdm-flows/form'));

const SDMLayout = () => (
    <Suspense fallback={<div />}>
        <Header backLink={<Link to="/learn/decision/supported" style={{ paddingRight: 45, color: 'white', fontWeight: 600 }}>Back to Resources</Link>} />
        <main style={{ backgroundColor: Colors.background, height: 'calc(100vh - 76px)' }}>
            <Container sx={{ py: { xs: 4, md: 10 }, px: 4, height: '100%' }}>
                <Routes>
                    <Route path="/learn" element={<SDMLearn />} />
                    <Route path="/form" element={<SDMForm />} />
                    <Route path="/*" element={<Navigate replace to="/error/404" />} />
                </Routes>
            </Container>
        </main>
    </Suspense>
);

export default withRoot(SDMLayout, themer);
